import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  Select as MuiSelect,
  MenuItem,
  FormHelperText,
  Checkbox,
} from "@mui/material";

export default function Select(props) {
  const {
    name,
    label,
    className,
    value,
    error = null,
    onChange,
    options,
    multiple = false,
  } = props;
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <FormControl
      className={className}
      variant="outlined"
      {...(error && { error: true })}
    >
      <InputLabel>{label}</InputLabel>
      <MuiSelect
        label={label}
        name={name}
        className={className}
        value={value}
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
        multiple={multiple}
        onChange={onChange}
      >
        <MenuItem disabled value="">
          <em>{label}</em>
        </MenuItem>
        {options.map((item) => (
          <MenuItem key={item} value={item}>
            {multiple && open ? (
              <Checkbox checked={value.indexOf(item) > -1} />
            ) : null}

            {item}
          </MenuItem>
        ))}
      </MuiSelect>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
}
